import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import useJiriHeaderItems from '@/modules/jiri/useJiriHeaderItems'
import Notifications from '@/modules/notifications/Notifications'
import useProfileHeaderItems from '@/modules/profile/useProfileHeaderItems'
import { getNotificationsThunk, markAllNotificationsReadThunk } from '@/redux/slices/notificationSlice'
import { useAppDispatch } from '@/redux/store'
import { Stack, useFocusEffect } from 'expo-router'
import { useCallback } from 'react'

export default function NotificationsPage() {
  const dispatch = useAppDispatch()
  const jiriHeaderItems = useJiriHeaderItems()
  const profileHeaderItems = useProfileHeaderItems()

  useFocusEffect(
    useCallback(() => {
      dispatch(getNotificationsThunk({ page: 1 }))
    }, [dispatch])
  )

  const handleMarkAllReadPress = async () => {
    await dispatch(markAllNotificationsReadThunk())
  }

  return (
    <>
      <Stack.Screen
        options={{
          ...buildScreenHeaderItems({
            left: profileHeaderItems,
            right: [
              {
                type: 'menu',
                label: '菜单',
                icon: {
                  type: 'sfSymbol',
                  name: 'ellipsis',
                },
                menu: {
                  items: [
                    {
                      type: 'action',
                      label: '全部标记已读',
                      onPress: handleMarkAllReadPress,
                    },
                  ],
                },
              },
              ...jiriHeaderItems,
            ],
          }),
        }}
      />

      <Notifications />
    </>
  )
}
